import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUserFromToken } from '../../utils/adminApi';
import { getRoleDashboardPath } from '../../utils/roleDashboard';
import { canUseWhiteboard } from './whiteboardRoles';

const TrainingProtectedRoute = ({ children }) => {
  const user = getUserFromToken();
  if (!user) return <Navigate to="/login" replace />;
  if (!canUseWhiteboard(user.role)) return <Navigate to={getRoleDashboardPath(user.role)} replace />;
  return children;
};

export default TrainingProtectedRoute;
